import type { LucideIcon } from 'lucide-react';
import { CalendarCheck, Check, MessageSquare } from 'lucide-react';

/**
 * Presentation helpers for MembersPage (#3218), split out of the page module so
 * the page file only exports its component (react-refresh/only-export-components)
 * while the test can still import these directly.
 */

/** S3 pillar icons are chrome, not copy. Keyed by each pillar's stable `id` (not
 *  array position), so adding, removing or reordering a pillar in the content
 *  definition cannot mis-pair or crash on an out-of-range index. Pinned by
 *  MembersPage.test.tsx (every pillar id must have a mapping). */
export const PILLAR_ICONS: Record<string, LucideIcon> = {
  plan: CalendarCheck,
  updates: MessageSquare,
  checkin: Check,
};

/** Split `text` around the FIRST occurrence of `emphasis` (once). `indexOf` +
 *  slice, not `String.split`, so a word that repeats in the sentence does not
 *  drop the trailing segments. Returns null when the word is absent. */
export function splitEmphasis(
  text: string,
  emphasis: string,
): { before: string; match: string; after: string } | null {
  const idx = text.indexOf(emphasis);
  if (idx === -1) return null;
  return {
    before: text.slice(0, idx),
    match: emphasis,
    after: text.slice(idx + emphasis.length),
  };
}
